import { getBetHistory } from "@/lobby_common/api/game_gen";
import { divideAccuracy, divideSymbol } from "@/lobby_common/utils/utils.js";
import { formatTimeToString } from "@/lobby_common/utils/date";
import vueSeamlessScroll from "@/lobby_common/components/vue-seamless-scroll/index.vue";

export default {
  name: "Mode12",
  props: {
    curindex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      formatTimeToString,
      divideSymbol,
      active: 1,
      list: [],
      listBig: [],
      timer: null,
      emptyCount: 0,
      classOption: {
        direction: 0,
        singleHeight: 50,
        step: 2,
        openTouch: false,
        // limitMoveNum: 10,
      },
      classOptionH5: {
        openTouch: false,
        direction: 0,
        singleHeight: 30,
        hoverStop: false,
        step: 2,
        // limitMoveNum: 10,
      },
    };
  },
  computed: {
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    formatList() {
      // if (this.active === 0) {
      //   return this.list.slice(0, 20);
      // }
      // return this.listBig.slice(0, 20);
      // return this.list.slice(0, 20);
      return this.list;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    getSite() {
      return this.$store.getters.getPacketConfig?.site || {};
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.coinList || [];
    },
    isInActivity() {
      return (
        this.$store.getters.getAllEnableFeature?.activityTypes.includes(
          "ActivityTypeRank"
        ) ||
        this.$store.getters.getAllEnableFeature?.activityTypes.includes(
          "ActivityTypeTeamRank"
        )
      );
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config?.titleAlignment
    },
  },
  watch: {
    "$route.path"(n, o) {
      if (n === "/home") {
        // console.log("进入投注");
        this.init();
      }
      if (o === "/home") {
        // console.log("离开投注");
        this.clearTimer();
      }
    },
  },
  mounted() {
    this.getChooseCurrency();
    this.init();
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    handleParentClick(event) {
      const key = event.target.getAttribute("data-key");
      const item = this.formatList.find((e) => e.key === key);
      if (item) {
        this.$eventPost("click", {
          eid: `101_24_${this.curindex}_0`,
          gameGroupSid: item.gameGroupSid,
          time: Date.now(),
        });
        this.$refs.jpDetailDialog.show(item);
      }
    },
    ScrollEnd() {
      // console.log('ScrollEnd')
    },
    // 获取可选流通货币
    async getChooseCurrency() {
      this.coinBase =
        this.coinList.find((i) => i.coinCode === this.coin_code) || {};
      // console.log("this.coinBase", this.coinBase);
    },
    async init() {
      const betData = await this.getData();
      let originData = betData.list;
      if (originData.length < 1) {
        this.emptyCount++;
      } else {
        this.emptyCount = 0;
      }

      if (this.emptyCount > 2) {
        this.clearTimer();
        return;
      } // 超过2次没数据就停止轮询

      originData = originData.map((e) => {
        const gameInfo = betData.gameInfo[e.gameGroupSid] || {};
        return {
          ...e,
          key: window.crypto.randomUUID(),
          ...gameInfo,
          miniOrH5: gameInfo.gameH5Icon,
          appOrPcUrl: gameInfo.gamePcIcon,
          // gameName: gameInfo.gameName,
          coin_icon: betData.coinIcons[e.coinCode],
          // eid: `101_24_${this.curindex}_${e.gameGroupSid}`,
          // oid: `101_24_${this.curindex}_0`,
        };
      });
      originData = originData.filter(
        (e) => e.miniOrH5 !== "" && e.appOrPcUrl !== ""
      );

      this.clearTimer();

      if (this.active === 0) {
        this.list = originData.slice(0, 50);
        // if (this.list.length > 20) {
        //   this.list = this.list.slice(0, 20);
        // }
        if (this.$refs) {
          this.$refs?.seamlessScroll?.reset();
        }
      }
      this.list = originData.slice(0, 50);
      this.listBig = originData.slice(0, 50);
      // this.timer = setInterval(async () => {
      //   const data = originData.pop();
      //   if (!data) {
      //     this.init();
      //     return;
      //   }

      //   if (this.active === 0) {
      //     this.list.push(data);
      //     if (this.list.length > 50) {
      //       this.list = this.list.slice(0, 50);
      //     }
      //     // this.$refs.seamlessScroll.reset()
      //   }
      //   if (this.active === 1) {
      //     this.listBig.push(data);
      //     if (this.listBig.length > 50) {
      //       this.listBig = this.listBig.slice(0, 50);
      //     }
      //     // this.$refs.seamlessScroll.reset()
      //   }
      // }, 1500);
    },
    async getData() {
      const betType = this.active === 0 ? "BET" : "JACKPOT";
      const res = await getBetHistory({
        limit: 200,
        betType,
      });
      if (res.code !== 0) {
        return {
          list: [],
          gameInfo: {},
          coinIcons: {},
        };
      }
      return {
        list: res.data.list || [],
        gameInfo: res.data.gameInfo || {},
        coinIcons: res.data.coinIcons || {},
      };
    },
    clearTimer() {
      this.timer && clearInterval(this.timer);
    },
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    handleItem(active, eid) {
      if (this.active === active) {
        return false;
      }
      // if (active === 2 && !this.$store.getters.taken) {
      //   this.$Bus.$emit('showLogin')
      //   return false;
      // }
      this.active = active;
      this.$eventPost("click", {
        eid: eid,
        time: Date.now(),
      });
      this.clearTimer();
      this.list = [];
      this.listBig = [];
      this.emptyCount = 0;
      this.init();
    },
  },
};
